// extracted by mini-css-extract-plugin
export default {"App":"Support_App__aU0gQ","hr":"Support_hr__5CSCo","input":"Support_input__w7u++","button":"Support_button__GL8Wh"};